import { Modals, Translations } from '@typings';
import { createAction } from 'typesafe-actions';

export const hideModal = createAction('ui/HIDE_MODAL')<Modals.Type>();
export const showModal = createAction('ui/SHOW_MODAL')<Modals.Type>();

export const toggleNetworkConnectivity = createAction('ui/NETWORK_CONNECTIVITY_TOGGLE')<{
  isOffline: boolean;
}>();

export const setProductsGridSize = createAction('ui/SET_PRODUCTS_GRID_SIZE')<'small' | 'medium' | 'large'>();
export const setProductsGridView = createAction('ui/SET_PRODUCTS_GRID_VIEW')();
export const setProductsListView = createAction('ui/SET_PRODUCTS_LIST_VIEW')();

export const toggleProductsGroupedByDelwin = createAction('ui/PRODUCTS_GROUPED_BY_DELWIN_TOGGLE')();

export const setSoftLogoutMode = createAction('ui/SET_SOFT_LOGOUT_MODE')();

export const setShouldShowMoreShippingAddresses = createAction('order/SET_SHOULD_SHOW_MORE_SHIPPING_ADDRESSES')<boolean>();
export const resetAppState = createAction('ui/RESET_APP_STATE')();
export const requestLanguageChange = createAction('ui/REQUEST_LANGUAGE_CHANGE')<Translations.SupportedLanguagesCodes>();

export const setMatrixTotalsColumnPinned = createAction('ui/SET_MATRIX_TOTALS_COLUMN_PINNED')<boolean>();

export const redirectedUserToLatestSelection = createAction('ui/REDIRECTED_USER_TO_LATEST_SELECTION')();

export const setIsMenuOpen = createAction('ui/SET_IS_MENU_OPEN')<boolean>();

export const setLookbookProductsGridSize = createAction('ui/SET_LOOKBOOK_PRODUCTS_GRID_SIZE')<'small' | 'medium' | 'large'>();
